import { formatCurrency } from '@servicetitan/financing-utils-shared';
import { Message } from '../../common/components/Message';

interface InvalidLoanAmountStateProps {
    minimumLoanAmount?: number;
    maximumLoanAmount?: number;
}

export const InvalidLoanAmountState = ({
    minimumLoanAmount,
    maximumLoanAmount,
}: InvalidLoanAmountStateProps) => {
    const getHeadline = () => {
        if (minimumLoanAmount != null && maximumLoanAmount != null) {
            return `Desired financed amount must be between ${formatCurrency(minimumLoanAmount)} and ${formatCurrency(maximumLoanAmount)}`;
        }
        if (minimumLoanAmount != null) {
            return `Desired financed amount must be at least ${formatCurrency(minimumLoanAmount)}`;
        }
        if (maximumLoanAmount != null) {
            return `Desired financed amount must be no more than ${formatCurrency(maximumLoanAmount)}`;
        }
        return 'Invalid loan amount';
    };

    return (
        <Message
            headline={getHeadline()}
            detail="Try editing your financing information and searching again."
        />
    );
};
